import { render, staticRenderFns } from "./Dy4GDeviceInfo.vue?vue&type=template&id=00d8737b&"
import script from "./Dy4GDeviceInfo.vue?vue&type=script&lang=js&"
export * from "./Dy4GDeviceInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports